const popup = (id) => {

    const popup     = $(id.attr('href'));
    const close     = $('.js-close-popup');

    const player    = $('#audio-player');
    const track     = player.find('.js-media-controller-title');
    const download  = player.find('.js-media-controller-download');
    const control   = player.find('.js-media-controller');

    if ( popup.length ) {
        id.magnificPopup({
            type            :'inline',
            removalDelay    : 200,
            midClick        : true,
            callbacks       : {
                beforeOpen  : function() {
                    this.st.mainClass = this.st.el.attr('data-effect');
                    const id = this.st.el.attr('href');

                    if (typeof this.st.el.attr('data-url') !== 'undefined') {
                        const title = this.st.el.attr('data-title');
                        const url   = this.st.el.attr('data-url');

                        player.find('source').attr('src', url);
                        document.getElementById('audio-popup').load();

                        track.text(title);
                        download.attr('href', url);

                        audioDurationHandler();

                        function audioDurationHandler() {
                            let duration    = 0;
                            const audio     = document.getElementById('audio-popup');
                            const timer     = control.find('.media-controller__timer');

                            audio.addEventListener('loadedmetadata', function () {
                                if ( audio.readyState > 0 ) {
                                    const minutes  = parseInt(audio.duration / 60, 10);
                                    const seconds  = parseInt(audio.duration % 60);
                                    duration = minutes+":"+seconds;

                                    timer.text(duration);
                                }
                            });
                        }
                    }
                    if (typeof this.st.el.attr('data-comparison') !== 'undefined') {
                        setTimeout(function(){
                            comparisonTable(id);
                        }, 210);
                    }
                },
                open        : function () {},
                close       : function () {
                    if (typeof this.st.el.attr('data-url') !== 'undefined') {
                        document.getElementById('audio-popup').pause();
                        player.find('source').attr('src', '');

                        if ( control.hasClass('_playing') ) {
                            control.removeClass('_playing').addClass('_paused');
                        }
                    }
                }
            }
        });

        close.on('click', function(){
            $.magnificPopup.proto.close.call(this);
        });
    }
}
